import {
  useBoolean,
  InputProps,
  InputRightElement,
  IconButton,
} from '@chakra-ui/react'
import React from 'react'
import { VisibilityOn, VisibilityOff } from '../../../icons'
import { useColor } from '../../../theme'
import { AuthInput, IAuthInputProps } from '../AuthInput'
import type { IFormValidationProps } from '../hooks'

export const AuthPasswordInput = React.forwardRef<
  HTMLInputElement,
  IAuthInputProps & IFormValidationProps & InputProps
>(({ ...rest }, ref) => {
  const [showPassword, setShowPassword] = useBoolean(false)

  const handleShowPassword = setShowPassword.toggle

  const iconColor = useColor({
    nuance: 6,
    palette: 'text',
  })

  return (
    <AuthInput
      data-testid="auth-password-input"
      ref={ref}
      rightElement={
        <InputRightElement h="full">
          <IconButton
            _hover={{
              bg: 'inherit',
              border: 'inherit',
            }}
            aria-label={showPassword ? 'Show' : 'Hide'}
            border="inherit"
            color={iconColor}
            data-testid="auth-password-input-icon-button"
            icon={showPassword ? <VisibilityOn /> : <VisibilityOff />}
            onClick={handleShowPassword}
            variant="ghost"
          />
        </InputRightElement>
      }
      type={showPassword ? 'text' : 'password'}
      {...rest}
    />
  )
})
